import React, { Suspense } from  'react';
import RightNav from './Home/RightNav';
import { Outlet } from 'react-router-dom';
import Footer from './Home/Footer/Footer';
import PageLoader from './PageLoader/PageLoader';

export default function DefaultLayout() {

    return(
        <>
            <RightNav />
            {/* Ładowanie strony (lazy) podmienia tylko treść – menu i stopka zostają na miejscu */}
            <Suspense fallback={<PageLoader />}>
                <Outlet />
            </Suspense>
            <Footer />
        </>
    )

}
